import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';

import { TituloReceberIntegracaoErpImportModalComponent } from './modal';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TituloReceberIntegracaoErpImportModalComponent
    ],
    exports: [
        TituloReceberIntegracaoErpImportModalComponent
    ]
})
export class TituloReceberIntegracaoErpImportModule { }
